/**
 * Clock/date text pinned to Asia/Kolkata, whatever the browser's own zone is.
 *
 * `lib/format.ts`'s `clock()`/`dateTime()` render in the machine's local zone, which is
 * the right call for the live wall display (it sits in an IST ops room). Reports are
 * different: an exported xlsx or a drawer screenshot travels, and a manager opening it
 * from a laptop set to UTC must read the same "22:14" the depot did -- the alert-report
 * SQL buckets day/night on IST (db/reports_driver_tims.sql's started_at_night, 22:00-06:00
 * IST), so a clock that silently shifted with the viewer's zone would contradict the
 * shift column sitting next to it.
 */

export const IST_ZONE = 'Asia/Kolkata'

const CLOCK = new Intl.DateTimeFormat('en-IN', {
  timeZone: IST_ZONE, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
})
const DATE_TIME = new Intl.DateTimeFormat('en-IN', {
  timeZone: IST_ZONE, day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false,
})

/** "22:14:07" in IST; em dash for a missing timestamp (same null rule as lib/format.ts). */
export function istClock(ts: number | null | undefined): string {
  if (ts == null || !Number.isFinite(ts)) return '—'
  return CLOCK.format(new Date(ts))
}

/** "22 Sep, 22:14" in IST -- for lists that may span days. */
export function istDateTime(ts: number | null | undefined): string {
  if (ts == null || !Number.isFinite(ts)) return '—'
  // en-IN renders "22 Sept, 22:14" with a trailing-comma month in some ICU versions; the
  // replace normalises both spellings to the one the rest of the console prints.
  return DATE_TIME.format(new Date(ts)).replace('Sept', 'Sep')
}
